import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PopoverOnHover from './PopoverOnHover';
export var TooltipOnHover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TooltipOnHover, _React$Component);

  function TooltipOnHover() {
    _classCallCheck(this, TooltipOnHover);

    return _possibleConstructorReturn(this, _getPrototypeOf(TooltipOnHover).apply(this, arguments));
  }

  _createClass(TooltipOnHover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          placement = _this$props.placement,
          tooltipContent = _this$props.tooltipContent,
          delayShow = _this$props.delayShow;

      if (disabled) {
        return children;
      }

      return React.createElement(PopoverOnHover, {
        id: this.props.id,
        delayShow: delayShow,
        position: placement,
        content: React.createElement("div", {
          className: classNames('tooltip', 'font-size-small font-weight-bold', 'padding-vertical-small padding-horizontal-medium', 'radius-normal', 'shadow-large')
        }, tooltipContent)
      }, children);
    }
  }]);

  return TooltipOnHover;
}(React.Component);

_defineProperty(TooltipOnHover, "propTypes", {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  tooltipContent: PropTypes.node.isRequired,
  placement: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  delayShow: PropTypes.number
});

_defineProperty(TooltipOnHover, "defaultProps", {
  placement: 'bottom',
  delayShow: 400
});

export default TooltipOnHover;